<template>
    <div>
        <div
            v-for="(item, index) in items"
            :key="index"
            class="border-b border-[#ffffff24] mx-4"
            role="tablist"
        >
            <button
                :id="`nav_accordion__tab_${index}`"
                :aria-selected="active === index"
                :aria-controls="`nav_accordion__panel_${index}`"
                class="flex items-center justify-between w-full text-white font-semibold hover:text-[#E4097E] appearance-none py-4"
                type="button"
                @click.prevent="setActiveTab(index)"
            >
                <div class="uppercase text-[#e4097e]">
                    {{ item.title }}
                </div>
                <fa-icon :icon="['fas', active === index ? 'minus' : 'add']" size="xs" fixed-width />
            </button>
            <div
                :id="`nav_accordion__panel_${index}`"
                :aria-hidden="active !== index"
                :aria-labelledby="`nav_accordion__tab_${index}`"
                :class="{
                    'pb-4 px-4': true,
                    'flex flex-col': active === index,
                    'hidden': active !== index
                }"
                role="tabpanel"
            >
                <a
                    v-for="(childItem, subIndex) in item.children"
                    :key="subIndex"
                    :href="childItem.url"
                    class="w-full py-1"
                >
                    {{ childItem.title }}
                </a>
            </div>
        </div>
        <div class="border-b border-[#ffffff24] mx-4" role="tablist">
            <button
                id="nav_accordion__tab_contact"
                :aria-selected="active === 'get_in_touch'"
                aria-controls="nav_accordion__panel_contact"
                class="flex items-center justify-between text-white font-semibold hover:text-[#E4097E] w-full py-4"
                type="button"
                role="tab"
                @click.prevent="setActiveTab('get_in_touch')"
            >
                <div class="uppercase text-[#e4097e]">
                    Get In Touch
                </div>
                <fa-icon :icon="['fas', active === 'get_in_touch' ? 'minus' : 'add']" size="xs" fixed-width/>
            </button>
            <div
                id="nav_accordion__panel_contact"
                :aria-hidden="active !== 'get_in_touch'"
                aria-labelledby="nav_accordion__tab_contact"
                :class="{
                    'py-4 px-4': true,
                    'flex flex-col': active === 'get_in_touch',
                    'hidden': active !== 'get_in_touch'
                }"
                role="tabpanel"
            >
                <div class="text-white">
                    Transmit Startups, Northern Design Centre, Abbotts Hill, Baltic Business Quarter, Gateshead, NE8 3DF
                </div>
                <div class="w-full md:w-auto md:flex-auto">
                    <h3 class="text-center underline p-6">
                        <fa-icon :icon="['fas', 'envelope']" size="lg" fixed-width class="text-[#c50a6e] pr-2" /><a href="mailto:info@transmitstartups.co.uk" target="_blank" rel="noopener">info@transmitstartups.co.uk</a>
                    </h3>
                    <div class="flex">
                        <a href="https://www.facebook.com/Starting-a-business-with-Transmit-Startups-108187944982138" target="_blank" rel="noopener" class="flex-auto text-center" aria-label="Visit our Facebook">
                            <fa-icon :icon="['fab', 'facebook-f']" size="lg" fixed-width />
                        </a>
                        <a href="https://twitter.com/transmitstartup" target="_blank" rel="noopener" class="flex-auto text-center" aria-label="Visit our Twitter">
                            <fa-icon :icon="['fab', 'twitter']" size="lg" fixed-width />
                        </a>
                        <a href="https://www.linkedin.com/company/transmit-start-ups" target="_blank" rel="noopener" class="flex-auto text-center" aria-label="Visit our LinkedIn">
                            <fa-icon :icon="['fab', 'linkedin-in']" size="lg" fixed-width />
                        </a>
                        <a href="https://www.youtube.com/channel/UCgjiyxQmou5hValRLpi2T_A" target="_blank" rel="noopener" class="flex-auto text-center" aria-label="Visit our YouTube">
                            <fa-icon :icon="['fab', 'youtube']" size="lg" fixed-width />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'NavigationAccordion',

    props: ['items'],

    data () {
        return {
            active: null
        }
    },

    methods: {
        setActiveTab (tab) {
            this.active = this.active === tab ? null : tab
        }
    }
}
</script>

